import { useDrawingArea, useXScale } from "@mui/x-charts"
import { Fragment } from "react"
import { extraColors } from "../../utils/theme"

export const FadeOverlay = () => {
  const { left, top, width, height } = useDrawingArea()
  const xScale = useXScale<"band">("weeksAxis")

  const domain = xScale.domain()
  if (domain.length === 0) return null

  const first = domain[0]
  const last = domain[domain.length - 1]
  if (first == null || last == null) return null

  const firstX = xScale(first)
  const lastX = xScale(last)
  const bandwidth = xScale.bandwidth()

  const showLeftFade = firstX !== undefined && firstX < left - 1
  const showRightFade =
    lastX !== undefined && lastX + bandwidth > left + width + 1

  if (!showLeftFade && !showRightFade) return null

  return (
    <Fragment>
      <defs>
        <linearGradient id="fade-gradient-left" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor={extraColors.dark} stopOpacity={1} />
          <stop offset="100%" stopColor={extraColors.dark} stopOpacity={0} />
        </linearGradient>
        <linearGradient id="fade-gradient-right" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor={extraColors.dark} stopOpacity={0} />
          <stop offset="100%" stopColor={extraColors.dark} stopOpacity={1} />
        </linearGradient>
      </defs>
      {showLeftFade && (
        <rect
          x={left}
          y={top}
          width={60}
          height={height}
          fill="url(#fade-gradient-left)"
          style={{ pointerEvents: "none" }}
        />
      )}
      {showRightFade && (
        <rect
          x={left + width - 60}
          y={top}
          width={60}
          height={height}
          fill="url(#fade-gradient-right)"
          style={{ pointerEvents: "none" }}
        />
      )}
    </Fragment>
  )
}
